import { PERMISSION_RESOURCE_CODES as R } from '../../src/permissions/definitions';
import type { AppRoute } from '../routes';

const boundary = '@/modules/zy-hr/EmployeeDomainBoundary';
const base = '/performance-center';
const page = (
  suffix: string,
  name: string,
  resource: string,
  component: string,
  icon?: string,
): AppRoute => ({
  path: `${base}${suffix}`,
  name,
  icon,
  permissionResourceCode: resource,
  component: `./zy-hr/${component}`,
});
const detail = (
  suffix: string,
  resource: string,
  component: string,
  parent: string,
): AppRoute => ({
  ...page(suffix, '', resource, component),
  hideInMenu: true,
  parentKeys: [base, `${base}${parent}`],
});

export const performanceRoutes: AppRoute[] = [
  {
    path: base,
    name: '绩效中心',
    icon: 'barChart',
    wrappers: [boundary],
    routes: [
      {
        path: `${base}/`,
        hideInMenu: true,
        component: './Platform/OverviewRedirect',
      },
      page(
        '/overview',
        '概览',
        R.performanceOverview,
        'PerformanceCenter',
        'dashboard',
      ),
      page(
        '/approval',
        '我的审批',
        R.performanceApproval,
        'PerformanceApprovalCenter',
        'audit',
      ),
      {
        path: '',
        key: 'performance-execution',
        name: '考核管理',
        icon: 'schedule',
        routes: [
          page(
            '/cycles',
            '考核周期',
            R.performanceCycles,
            'PerformanceCycleList',
          ),
          detail(
            '/cycles/new',
            R.performanceCycles,
            'PerformanceCycleSetup',
            '/cycles',
          ),
          detail(
            '/cycles/:uuid/setup',
            R.performanceCycles,
            'PerformanceCycleSetup',
            '/cycles',
          ),
          detail(
            '/cycles/:uuid',
            R.performanceCycles,
            'PerformanceCycleDetail',
            '/cycles',
          ),
          page('/goals', '绩效目标', R.performanceGoals, 'PerformanceGoalList'),
          detail(
            '/goals/:uuid',
            R.performanceGoals,
            'PerformanceGoalDetail',
            '/goals',
          ),
          page(
            '/reviews',
            '绩效评估',
            R.performanceReviews,
            'PerformanceReviewList',
          ),
          detail(
            '/reviews/:uuid',
            R.performanceReviews,
            'PerformanceReviewDetail',
            '/reviews',
          ),
          page(
            '/calibration-batches',
            '绩效校准',
            R.performanceCalibrationBatches,
            'PerformanceCalibrationBatchList',
          ),
        ],
      },
      {
        path: '',
        key: 'performance-process-results',
        name: '面谈与结果',
        icon: 'fileDone',
        routes: [
          page(
            '/interviews',
            '绩效面谈',
            R.performanceInterviews,
            'PerformanceInterviewList',
          ),
          detail(
            '/interviews/:uuid',
            R.performanceInterviews,
            'PerformanceInterviewDetail',
            '/interviews',
          ),
          page(
            '/results',
            '绩效结果',
            R.performanceResults,
            'PerformanceResultList',
          ),
          detail(
            '/results/:uuid',
            R.performanceResults,
            'PerformanceResultDetail',
            '/results',
          ),
        ],
      },
      {
        path: '',
        key: 'performance-team',
        name: '团队绩效',
        icon: 'team',
        hideInMenu: true,
        routes: [
          {
            ...page('/team', '团队绩效', R.performanceTeam, 'PerformanceTeam'),
            hideInMenu: true,
          },
          detail(
            '/team/goals/:uuid',
            R.performanceTeam,
            'PerformanceTeamGoalDetail',
            '/team',
          ),
          detail(
            '/team/reviews/:uuid',
            R.performanceTeam,
            'PerformanceTeamReviewDetail',
            '/team',
          ),
        ],
      },
      page(
        '/profiles',
        '绩效档案',
        R.performanceProfiles,
        'PerformanceProfileList',
        'idcard',
      ),
      detail(
        '/profiles/:employeeUuid',
        R.performanceProfiles,
        'PerformanceProfileDetail',
        '/profiles',
      ),
      page(
        '/audits',
        '操作记录',
        R.performanceAudits,
        'PerformanceAuditList',
        'history',
      ),
      {
        path: '',
        key: 'performance-settings',
        name: '绩效设置',
        icon: 'setting',
        routes: [
          page(
            '/cycle-templates',
            '考核模板',
            R.performanceCycleTemplates,
            'PerformanceCycleTemplateList',
          ),
          detail(
            '/cycle-templates/new',
            R.performanceCycleTemplates,
            'PerformanceCycleTemplateForm',
            '/cycle-templates',
          ),
          detail(
            '/cycle-templates/:uuid/edit',
            R.performanceCycleTemplates,
            'PerformanceCycleTemplateForm',
            '/cycle-templates',
          ),
          page(
            '/score-templates',
            '评分模板',
            R.performanceScoreTemplates,
            'PerformanceScoreTemplateList',
          ),
          detail(
            '/score-templates/new',
            R.performanceScoreTemplates,
            'PerformanceScoreTemplateForm',
            '/score-templates',
          ),
          detail(
            '/score-templates/:uuid/edit',
            R.performanceScoreTemplates,
            'PerformanceScoreTemplateForm',
            '/score-templates',
          ),
          page(
            '/grade-rules',
            '绩效等级',
            R.performanceGradeRules,
            'PerformanceGradeRuleList',
          ),
          page(
            '/workflow-settings',
            '审批流程设置',
            R.performanceWorkflowSettings,
            'PerformanceWorkflowSettings',
          ),
        ],
      },
    ],
  },
];
